
  import { Component, Watch, Vue }          from 'vue-property-decorator';
  import { Getter, Action }                 from 'vuex-class';
  import { EventBus,
           ConfigService,
           ResponsiveUiHelper,
           ConfigThemeService,
           DialogEntity,
           MessageEntity,
           AttachmentTypeEnum,
           BotMessageTypeEnum, 
           MessageOriginEnum,
           NotificationEntity}              from '../..';
  
  import   HeaderComponent                  from '../header/HeaderComponent.vue';
  import   ScreenReaderOnlyNavBarComponent  from '../navbar/ScreenReaderOnlyNavBarComponent.vue';
  import   PopupScreenComponent             from '../popup/PopupScreenComponent.vue';
  import   DrawerComponent                  from '../drawer/DrawerComponent.vue';
  import   EmotionAvatarComponent           from '../avatar/EmotionAvatarComponent.vue';
  import   FeedbackComponent                from '../feedback/FeedbackComponent.vue';
  import   TyperComponent                   from '../typer/TyperComponent.vue';
  import   BotAnswerLeafMessageComponent    from './BotAnswerLeafMessageComponent.vue';
  import   MessageComponent                 from './MessageComponent.vue';
  import   NotificationBoxComponent         from './NotificationBoxComponent.vue';


  @Component({
    name: 'ChatboxPanelComponent',
    components: {
      TyperComponent,
      EmotionAvatarComponent,
      MessageComponent,
      BotAnswerLeafMessageComponent,
      FeedbackComponent,
      PopupScreenComponent,
      DrawerComponent,
      HeaderComponent,
      NotificationBoxComponent,
      ScreenReaderOnlyNavBarComponent
    }
  })
  export default class ChatboxPanelComponent extends Vue {
    @Getter('currentDialog', { namespace: 'messages' }) currentDialog!: DialogEntity;
    @Getter('isRequestInProgress', { namespace: 'messages' }) isRequestInProgress!: boolean;
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;
    @Getter('latestMessageWatermark', { namespace: 'conversationSession' }) latestMessageWatermark!: number;
    @Getter('feedbackCurrentSessionScore', { namespace: 'conversationSession' }) feedbackCurrentSessionScore!: number;
    @Getter('getNotificationsToShow', { namespace: 'messages' }) getNotificationsToShow!: NotificationEntity[];
    @Getter('getNotifications', { namespace: 'messages' }) getNotifications!: NotificationEntity[];
    @Getter('isPresentationAvatarAllowed', { namespace: 'conversationSession' }) isPresentationAvatarAllowed!: boolean;
    @Action('resetNotification', { namespace: 'messages' }) resetNotification: any;

    isFullscreenDisplay: boolean = false;
    onWidgetScrolled: boolean = false;
    displayExperimentalMode: boolean = false;
    calculatedHeaderHeight: string = ``
    generalMargin :number =  5
    notificationMargin :number =  115
    notifStyle: any = this.updateNotificationStyle()
    headerContentHeight : number | undefined = 0

    @Watch('isPresentationAvatarAllowed')
    @Watch('onWidgetScrolled')
    initShift() {
      this.notifStyle = this.updateNotificationStyle()
      this.$nextTick(() =>{
        this.headerContentHeight = document.getElementById('header-content')?.offsetHeight;
        this.notifStyle = this.updateNotificationStyle()
        this.updateHeight()
      })
    }

    @Watch('getNotificationsToShow')
    updateHeight() {
      if (this.headerContentHeight  && !this.onWidgetScrolled) {
          if (this.getNotificationsToShow.length>0 ) {
            this.calculatedHeaderHeight = `${this.headerContentHeight+this.generalMargin+this.notificationMargin}px`
          } else {
            this.calculatedHeaderHeight = `${this.headerContentHeight+this.generalMargin}px`
          }
      }
    }

    get shiftMessagesStyle() {
      const {ratio , widthFullScreen, widthFloat} =  ConfigService.getNotificationBoxStyle()
      const cssHeightFullScreen =  `min(${widthFullScreen.vwWidth * ratio}vw, ${widthFullScreen.pxWidth * ratio}px)`
      const cssHeightFloat =  `min(${widthFloat.vwWidth * ratio}vw, ${widthFloat.pxWidth * ratio}px)`
      if (this.getNotificationsToShow.length > 0) {
        if (this.isEmbeddedMode || this.isFullscreenDisplay) {
          return {
            paddingTop:`calc(${cssHeightFullScreen} - 20px)`,
            animationName: 'shiftAnimFullScreen',
            animationDuration : '0.5s'
          }
        }
        return {
          animationName: 'shiftAnimFloat',
          animationDuration : '0.5s'
        }
      }
      return {}
    }

    updateNotificationStyle() {
      const r : HTMLElement = document.querySelector(':root') as HTMLElement
      const {ratio , widthFullScreen, widthFloat} =  ConfigService.getNotificationBoxStyle()
      const cssWidthFullScreen =  `min(${widthFullScreen.vwWidth}vw, ${widthFullScreen.pxWidth}px)`
      const cssWidthFloat =  `min(${widthFloat.vwWidth}vw, ${widthFloat.pxWidth}px)`
      const cssHeightFullScreen =  `min(${widthFullScreen.vwWidth * ratio}vw, ${widthFullScreen.pxWidth * ratio}px)`
      const cssHeightFloat = `min(${widthFloat.vwWidth * ratio}vw, ${widthFloat.pxWidth * ratio}px)`
      r.style.setProperty('--heightTransiFloat', cssHeightFloat)
      r.style.setProperty('--heightTransiFullScreen', cssHeightFullScreen)
      r.style.setProperty('--generalMargin', this.generalMargin+'px')
      const notifMargin = this.headerContentHeight ? this.headerContentHeight+20 : 0
      if(this.isEmbeddedMode || this.isFullscreenDisplay){
        return {
          marginTop: `${this.isEmbeddedMode ? 0 : notifMargin}px`,
          marginLeft: `calc((100% - (${cssWidthFullScreen}))/2)`,
          width: cssWidthFullScreen,
          animationName: 'notifAppearFullScreen',
          animationDuration: '0.5s',
          maxHeight: `calc(100vh - ${notifMargin}px)`,
          backgroundColor: 'white',
        }
      }
      return {
          marginTop: `${notifMargin}px`,
          marginLeft: `calc((100% - (${cssWidthFloat}))/2)`,
          width: cssWidthFloat,
          animationName: 'notifAppear',
          animationDuration: '0.5s',
          maxHeight: `calc(100vh - ${notifMargin}px)`,
          backgroundColor: 'white',
      }
    }

   onWindowResize() {
    this.notifStyle = this.updateNotificationStyle()
   }

    get showHeader() {
      return (this.isFullscreenDisplay || !this.isEmbeddedMode);
    }

    get messages() {
      return (this.currentDialog) ? this.currentDialog.messages.filter((msg :MessageEntity) => msg.type !== BotMessageTypeEnum.NOTIFICATION) : [];
    }

    get headerDecorationBannerStyles() {
      return ConfigThemeService.getHeaderDecorationBannerStyles(this.$vuetify);
    }

    get footerHeight() {
      return parseInt(ConfigThemeService.getTyperHeight(), 10) + 4;
    }

    get containerStyles() {
      return this.isEmbeddedMode ? ConfigThemeService.getEmbeddedModeStyles(this.$vuetify) 
                                 : ConfigThemeService.getFloatingModeStyles(this.$vuetify);
    }

    get loadingAnimationColor() {
      return ConfigThemeService.getLoadingAnimationColor(this.$vuetify);
    }

    get listContainerStructureStyles() {
      if (this.isEmbeddedMode) {
        return {};
      }
      return { marginBottom: `${ConfigThemeService.getTyperHeight()}px !important` };
    }

    get isExperimentalModeActivated() {
      return ConfigService.getExperimentalMode();
    }

    get truncatePolicy() {
      return ConfigService.getTruncatePolicy();
    }

    get textFontSize() {
      if(ConfigService.getDefaultPanelTextFontSize() !== undefined){
        return { fontSize : ConfigService.getDefaultPanelTextFontSize()+'px !important'};
      } else{ // if user didn't define font size => use breakpoints of ChatView.vue
        return {}; 
      }
    }

    // In embeded mode, the block listing the messages must have a fixed height equivalent to 100% - ( typer size + 5px (progress bar size)).
    get containerMsgListEmbededStructureStyles() {
      if (this.isEmbeddedMode && this.isFullscreenDisplay) {
        return { height: `calc(100% - ${parseInt(ConfigThemeService.getTyperHeight(), 10) + 5}px)` };
      }
      return {};
    }

    isBotAnwserLeafMessage(msg: MessageEntity) {
      let isLeafMsg: boolean = (msg.origin === MessageOriginEnum.BOT && msg.type === BotMessageTypeEnum.DOCUMENTATION_ANSWER
                                                                     && this.getButtonAttachmentsList(msg) === undefined);
      return isLeafMsg;
    }

    getButtonAttachmentsList(msg: MessageEntity) {
      return msg.attachments ? msg.attachments.get(AttachmentTypeEnum.BUTTON) : undefined
    }

    isMessageWithUnansweredSatisfactionQuestion(message : MessageEntity | any) {
      let hasUnansweredSatisfactionQuestion = false;
      // If the truncation policy is not "knowMore". See the documentation for this case.
      if (message.attachments && message.attachments.get(AttachmentTypeEnum.SATISFACTION_QUESTION) !== undefined) {
        let satisfactionAttachmentBtns: any[] = message.attachments.get(AttachmentTypeEnum.SATISFACTION_QUESTION);
        if (satisfactionAttachmentBtns) {
          // if the attachment is a SATISFACTION_QUESTION, block the user until it is answered
          hasUnansweredSatisfactionQuestion = (!satisfactionAttachmentBtns[0].buttons[0].alreadyClicked && 
                                               !satisfactionAttachmentBtns[0].buttons[1].alreadyClicked);
        }
      }
      return hasUnansweredSatisfactionQuestion;
    }

    /** ******************************************************************************************* */
    /**                                        LIFECYCLE HOOKS                                      */
    /** ******************************************************************************************* */

    created() {
      window.addEventListener("resize", this.onWindowResize);
      EventBus.$on('ON_RESIZE_SCREEN_MODE', (isFullscreen: boolean) => {
        this.isFullscreenDisplay = isFullscreen;
      });
      this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify);
      
    }

    mounted() {
      this.notifStyle = this.updateNotificationStyle()
      EventBus.$on('ON_MESSAGES_PANEL_SCROLLED', () => {
        if (ConfigThemeService.isActivatedScrollHeaderEffect() && (this.isFullscreenDisplay || !this.isEmbeddedMode)) {
          this.onWidgetScrolled = true;
        }
      });

      EventBus.$on('ON_SATISFACTION_FEEDBACK_DONE', () => {
        this.displayExperimentalMode = false;
      });

      if (this.feedbackCurrentSessionScore === 0) {
        EventBus.$emit('ON_DISPLAY_FEEDBACK_COMPONENT');
      }
    }

    destroyed() {
      EventBus.$off('ON_RESIZE_SCREEN_MODE');
    }

    /** ******************************************************************************************* */
    /**                                  WHATCHERS AND OBSERVERS                                    */
    /** ******************************************************************************************* */
    
    // Function to change the position of the scroll when a new message is received
    @Watch('messages', { immediate: false, deep: false }) 
    onMessagesChanged(val: string | any) {
      this.$nextTick(function () {
        // when adding a new message, we check if a scroll action is necessary
        let lastUserMessage = { index: 0, 
                                distance: 0, 
                                messageId: '', 
                                cumulativeMessageHeight: 0 };

        let cumulativeMessageHeight: number = 0;

        // We retrieve the information necessary to choose the type of scroll
        for (let i = val.length-1; i > 0; i--) { 
            if (val[i]['origin'] == 0) {
              lastUserMessage = { index: i, 
                                  distance: val.length-1 -i, 
                                  messageId: 'message-' + i, // L'id du div du message est défini en fonction de la key du v-for, soit le i du for
                                  cumulativeMessageHeight: cumulativeMessageHeight }
              break;
            } else {
              let elementOffsetHeight = document.getElementById('message-' + i);
              cumulativeMessageHeight += elementOffsetHeight ? elementOffsetHeight.offsetHeight : 0;
            }       
        }
        
        // If the bot messages exceed the window, we scroll back to the last user message, 
        // otherwise we position the scroll window at the bottom.
        let elmntMsgList = document.getElementById('chatbox-msg-list');
        if (lastUserMessage.distance > 0 && elmntMsgList 
                                         && lastUserMessage.cumulativeMessageHeight > (0.85 * elmntMsgList.offsetHeight)) {

          let elmnt = document.getElementById(lastUserMessage.messageId);
          if (elmnt) { elmnt.scrollIntoView(true); } 
          
        } else {
          let elmnt = document.getElementById('bottom-msg-list');
          if (elmnt) { elmnt.scrollIntoView(false); } 
        }
      });
    }

    // Function to detect when a new message is received
    @Watch('messages', { immediate: false, deep: false }) 
    onDialogChanged(messages: string | any) { 
        // If the experimental mode is activated
        if (this.isExperimentalModeActivated) {
          let isMessageWithSatisfactionBtns = false;
          
          // if the message is a satisfaction question, block the user until it is answered
          isMessageWithSatisfactionBtns = this.isBotAnwserLeafMessage(messages[messages.length-1]) && 
                                          this.isMessageWithUnansweredSatisfactionQuestion(messages[messages.length-1]);

          // We now test the next-to-last message
          if (!isMessageWithSatisfactionBtns && messages.length > 2 && messages[messages.length-2]) {
            isMessageWithSatisfactionBtns = this.isMessageWithUnansweredSatisfactionQuestion(messages[messages.length-2]);
          }

          // Set displayExperimentalMode according to isMessageWithSatisfactionBtns
          this.displayExperimentalMode = isMessageWithSatisfactionBtns;
        }
    }

    onScroll() {
      if (ConfigThemeService.isActivatedScrollHeaderEffect() && !this.onWidgetScrolled 
                                                             && (this.isFullscreenDisplay || !this.isEmbeddedMode)) {
        this.onWidgetScrolled = true;
      }
    }
  }
